// SectionHeader — bold 14px section heading.
// Mirrors `.section-h` in /Users/harry/Downloads/employee-portal/project/styles.css
// (line 1135). Used above lists inside drawers, panels, and side sheets.
//
// Spec: 14px / 600 / neutral.800 with a 10px bottom margin. The 10px gap sits
// between the `md` (12) and `1xs` (6) tokens, so we inline the literal value
// per the design spec ("inline as '10px' — not a token").

import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface SectionHeaderProps {
  children: ReactNode;
}

const SectionHeader = ({ children }: SectionHeaderProps) => {
  return (
    <Box
      fontSize="md"
      fontWeight={600}
      color="neutral.800"
      mb="10px"
    >
      {children}
    </Box>
  );
};

SectionHeader.displayName = "SectionHeader";

export default SectionHeader;
